module.exports = __webpack_public_path__ + "static/img/show-right.bc636f7a.png";